import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

interface DataRemainingProps {
  dataRemaining: number
}
export default function DataRemainingCard({
  dataRemaining
}: DataRemainingProps) {
  const finalDataLeft = (Math.round((dataRemaining / 1024) * 10) / 10).toFixed(
    1
  )

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#FFFFFF',
          borderRadius: '34px',
          p: '40px',
          maxWidth: '215px'
        }}
      >
        <NormalText
          isBold
          textAlign={'left'}
          sx={{
            fontSize: '24px',
            fontWeight: '700px',
            m: 0
          }}
          text={'Data left'}
        />
        <TextColorFontBody
          sx={{
            fontSize: '14px',
            lineHeight: 1,
            color: '#7B8794',
            textAlign: 'left',
            mt: '10px'
          }}
        >
          The total amount of data in GB that the customer has left for the
          month (rounded to 1 d.p)
        </TextColorFontBody>
        <Stack
          flexDirection={'row'}
          sx={{ mt: '37px', justifyContent: 'space-between' }}
        >
          <Stack>
            <Typography
              sx={{
                fontWeight: '400',
                color: '#7B8794',
                justifyContent: 'space-between'
              }}
              textAlign='left'
            >
              Status
            </Typography>

            <NormalText
              sx={{
                fontWeight: '600',
                fontSize: '33px',
                pt: '15px',
                color:
                  Number(finalDataLeft) !== 0
                    ? circlesOrbitColorPalette.success.main
                    : circlesOrbitColorPalette.error.main
              }}
            >
              {finalDataLeft} GB
            </NormalText>
          </Stack>
        </Stack>
      </Box>
    </>
  )
}
